var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-module-builder"},_vm._l((_vm.validComponents),function(pageModule){return _c('page-module',{key:((pageModule.__typename) + "-" + (pageModule.id) + "-" + _vm.locale),attrs:{"module":pageModule}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }